module.exports = __webpack_public_path__ + "static/media/trukfix-logo-data.5946dbc3.png";